/**
 * Shared helpers for the Send-Forms wizards (single-recipient dialog and
 * the campaign-style broadcast builder).
 *
 * Keep these in lockstep with the backend `validate_bcc()` logic on
 * ConsentRequestCreateSerializer / ConsentBroadcastCreateSerializer so the
 * client and server agree on what "20 emails, lowercased, deduped" means.
 */

// Strip / lowercase / dedupe a list of email strings (matches backend
// validate_bcc behaviour — keep client and server in sync).
export const normaliseEmails = (input) => {
    const seen = new Set();
    const result = [];
    (input || []).forEach((raw) => {
        const addr = String(raw || '').trim().toLowerCase();
        if (!addr || seen.has(addr)) return;
        seen.add(addr);
        result.push(addr);
    });
    return result.slice(0, 20); // server caps at 20
};

export const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e || '');

// Channel label/icon helpers — used in both wizards.
export const channelLabel = (ch) => ({
    EMAIL: 'Email',
    WHATSAPP: 'WhatsApp',
    COPY: 'Copy link',
    QR: 'QR code',
    SMS: 'SMS',
}[ch] || 'Send');

export const channelIcon = (ch) => ({
    EMAIL: 'solar:letter-bold-duotone',
    WHATSAPP: 'mdi:whatsapp',
    COPY: 'solar:link-round-bold-duotone',
    QR: 'solar:qr-code-bold-duotone',
    SMS: 'material-symbols:sms',
}[ch] || 'eva:paper-plane-fill');

// Lead → Patient text rewrite (used for user-visible copy only — never for
// state keys, prop names, or API payload field names).
export const leadCopyToPatient = (text = '') => String(text)
    .replace(/Leads/g, 'Patients')
    .replace(/Lead/g, 'Patient')
    .replace(/leads/g, 'patients')
    .replace(/lead/g, 'patient');
